module.exports = __webpack_public_path__ + "f3b86b40c20dae49b459303c6ff4d70f.pdf";